import { useQuery } from '@tanstack/react-query'
import {
	GetInviteFriendCommissionHistoryRequest,
	GetInviteFriendCommissionHistoryResponse,
} from '@/modules/promotion/type'
import { getInviteFriendCommissionHistoryList } from '../../services'
import { InviteFriendCommissionHistoryQueryKeys } from '@/modules/promotion/keys'

const useQueryGetInviteFriendCommissionHistory = (
	payload: GetInviteFriendCommissionHistoryRequest,
) => {
	return useQuery<GetInviteFriendCommissionHistoryResponse>({
		queryKey: [
			InviteFriendCommissionHistoryQueryKeys.GetInviteFriendCommissionHistoryList,
			payload,
		],
		queryFn: () => getInviteFriendCommissionHistoryList(payload),
	})
}

export default useQueryGetInviteFriendCommissionHistory
